export default "__VITE_ASSET__CaLegqla__"